// To prevent react-native-auth0 from being initialized on web
export default {};
